import React from 'react';
import {Row, Typography, Col, Icon, Button} from 'antd';

import './index.scss';
import landingImage from './landing.png'

const {Title, Text, Paragraph} = Typography;


function LandingPage() {
  return (
    <div className="__LandingPage__" style={{padding: '5rem', backgroundColor: '#fdfdfd'}}>
      <Row type="flex" justify="space-between" style={{minHeight: '66vh'}}>
        <Col>
          <Typography>
            <Title>First online hackathon platform</Title>
            <Title level={3}>A Collaboration tool that is tailored for remote hackatons.</Title>
            <Text>Currently hosting InAct - National Level Humanitarian Hackathon</Text>
          </Typography>
          <Button className="workspace-button" size="medium" type="primary" href="/inact-green-collaboration">Green
            Collaboration</Button>
          <Button className="workspace-button" size="medium" type="primary" href="/inact-enable">EnAble</Button>
          <Button className="workspace-button" size="medium" type="primary" href="/inact-stovathon-data">Stovathon
            Data</Button>
          <Button className="workspace-button" size="medium" type="primary" href="/inact-gender-gap">Gender Gap</Button>
          <Button className="workspace-button" size="medium" type="primary"
                  href="/inact-knowledge-ex">KnowledgeEx</Button>
          <Button className="workspace-button" size="medium" type="primary" href="/inact-blooming-forest">Blooming
            Forest</Button>
        </Col>
        <Col>
          <img className="only-desktop" alt="Online Collaboration" src={landingImage}/>
        </Col>
      </Row>

    </div>
  );
}

export default LandingPage;
